import React from 'react'
import Headers from '../headers/Headers'

const FreeQuotes = () => {
  return (
    <>
    <Headers/>
      <div>
        <h1>Free Quotes.</h1>
      </div>
    </>
  )
}

export default FreeQuotes
